import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import utils, { comnEnvs, comnUtils } from "@/comn/utils";
import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useStore, useToast, useResource, useModal, usePage } from "@/comn/hooks";
import {
    APIS,
    SF_NOTI_SRCH,
    SG_NOTI_LIST,
    URLS,
    SETTINGS_MAP,
} from "@/tra/tancis/ptli/ptl/noti/services/PtliNotiService";

/*
 * Notifice List
 * !== 알림 관리 목록 ==!
 */
export const PTLI1010001Q = (): JSX.Element => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0025", "auth_ptli0001", "auth_ptli0015", "auth_ptlianyADM"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal();
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "CGM0176" },
            { area: "comnCd", comnCd: "COM0024" },
            { area: "comnCd", comnCd: "PTL0020" },
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Notifice List Search !== 알림 목록 검색 ==!
        notiListSrch: useForm({
            defaultSchema: SF_NOTI_SRCH,
            defaultValues: { useYn: "Y", ...pgeStore?.form },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Notifice List !== 알림 목록 ==!
        notiList: useGrid({
            defaultSchema: SG_NOTI_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        //Check Notifice List !==  알림 목록 조회 ==!
        getNotiList: useFetch({
            api: (page = grid.notiList.page) =>
                APIS.getNotiList(form.notiListSrch.getValues(), page, grid.notiList.size),
            enabled: comnUtils.isEmpty(form.notiListSrch.errors),
            key: [grid.notiList.page, grid.notiList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.notiListSrch.getValues(),
                    page: grid.notiList.page,
                    size: grid.notiList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
            showToast: true,
        }),
    };
    const render = {
        cell: {
            notiNm: (props: any) => {
                const { rowValues, value } = props;
                return <Link to={`/ptli/ptl/noti/ptli1010003s/${rowValues.notiId}`}>{value}</Link>;
            },
            notiTpSettValue: (props: any) => {
                const { rowValues, value } = props;
                const enabledSettings: string[] = [];

                for (const key in SETTINGS_MAP) {
                    if (value & Number(key)) {
                        enabledSettings.push(SETTINGS_MAP[Number(key)]);
                    }
                }
                return enabledSettings.join(", ");
            },
            useYn: (props: any) => {
                const { rowValues, value } = props;

                return value === "Y" ? "Yes" : "No";
            },
        },
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Click Search Button !== 검색버튼 ==!
        onSrchBtnClick: (page: number = 0) => {
            grid.notiList.setPage(page);
            fetch.getNotiList.fetch(page);
        },
        //Click Registration Button  !== 등록 버튼 클릭 ==!
        onNewBtnClick: () => navigate(URLS.ptli1010002s),
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        handler.onSrchBtnClick(pgeStore?.page);
        console.log("test");
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.notiListSrch.schema.inexTpCd} />
                            <Group.Control {...form.notiListSrch.schema.bsopClsfCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.notiListSrch.schema.notiTpSettValueList} />
                            <Group.Control {...form.notiListSrch.schema.notiId} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.notiListSrch.schema.notiNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.notiListSrch.schema.useYn} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.notiListSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role={"search"}
                                onClick={() => {
                                    handler.onSrchBtnClick();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.notiList.grid} data={fetch.getNotiList.data?.notiList} render={render} />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"new"} onClick={handler.onNewBtnClick} />
                </Layout.Left>
            </Layout>
        </Page>
    );
};
